import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import { langCodeMap } from '../utils';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import { Trans } from './Trans';
import {
  MenuItem,
  Select,
  FormControl,
  SelectChangeEvent,
} from '@mui/material';

export const Home = () => {
  // const { tier } = getTokenValues();
  const params = useParams();
  return (
    <div
      className="p-5 text-gray-800 max-w-2xl mx-auto mt-[45vh] md:mt-[55vh]"
      style={{
        background: 'transparent',
        border: 'none',
        position: 'relative',
        zIndex: 100,
        fontFamily: 'Concert One',
      }}
    >
      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
              background-color: rgb(250, 92, 92);
            }
            50% {
              transform: scale(1.05);
              background-color: rgb(255, 70, 70);
            }
            100% {
              transform: scale(1);
              background-color: rgb(250, 92, 92);
            }
          }
        `}
      </style>
      <div className="flex justify-center items-center flex-col">
        <Button
          variant="contained"
          style={{
            backgroundColor: 'rgb(250, 92, 92)',
            color: 'white',
            fontSize: '1.5rem',
            padding: '10px 20px',
            marginTop: '20px',
            borderRadius: '20px',
            minWidth: '290px',
          }}
          startIcon={
            <SportsEsportsIcon style={{ height: '2em', width: 'auto' }} />
          }
          href="/app/home"
        >
          <Trans>Run the game</Trans>
        </Button>
        {/* {tier || localStorage.getItem('tier') ? (
          <Button
            variant="contained"
            style={{
              backgroundColor: 'rgb(250, 92, 92)',
              color: 'white',
              fontSize: '1.5rem',
              padding: '10px 20px',
              marginTop: '20px',
              borderRadius: '20px',
              minWidth: '290px',
            }}
            startIcon={
              <SportsEsportsIcon style={{ height: '2em', width: 'auto' }} />
            }
            href="/app/home"
          >
            <Trans>Run the game</Trans>
          </Button>
        ) : (
          <Button
            variant="contained"
            style={{
              backgroundColor: 'rgb(250, 92, 92)',
              color: 'white',
              fontSize: '1.5rem',
              padding: '10px 20px',
              marginTop: '20px',
              borderRadius: '20px',
              minWidth: '290px',
            }}
            startIcon={<ItchIcon />}
            href="https://lewdspace.itch.io/lewdspace"
          >
            <Trans>Play on itch.io</Trans>
          </Button>
        )} */}
        <Button
          variant="contained"
          style={{
            backgroundColor: 'rgb(83, 102, 245)',
            color: 'white',
            fontSize: '1.5rem',
            padding: '10px 20px',
            marginTop: '30px',
            borderRadius: '20px',
            minWidth: '290px',
          }}
          startIcon={<DiscordIcon />}
          href="https://discord.gg/gwZKNENRdx"
        >
          Discord
        </Button>
        <FormControl
          variant="outlined"
          sx={{ minWidth: 290 }}
          style={{ marginTop: '30px', backgroundColor: 'white' }}
        >
          <Select
            style={{ fontSize: '1.5rem', textAlign: 'center' }}
            value={params.lang || 'en'}
            onChange={(e: SelectChangeEvent<string>) =>
              (window.location.href = window.location.pathname.replace(
                params.lang || '',
                e.target.value
              ))
            }
            displayEmpty
            inputProps={{ 'aria-label': 'Select Language' }}
          >
            {Object.entries(langCodeMap).map(([code, name]) => (
              <MenuItem key={code} value={code}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <h1 className="text-center text-3xl font-bold mb-4 mt-14 md:mt-28">
        <Trans>Welcome to LewdSpace</Trans>
      </h1>
      <p className="mb-4 leading-relaxed">
        <Trans>
          The ultimate adult dating app simulator. Dive into a world of
          seduction and desire, where you'll meet and interact with 9 unique
          girls, each with their own personality, interests, and desires.
        </Trans>
      </p>
      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>Seduce your way to success</Trans>
      </h2>
      <p className="mb-4 leading-relaxed">
        <Trans>
          Engage in dynamic conversations, where every choice you make matters.
          Discover the perfect approach to win each girl's heart, and uncover
          their deepest desires. With multiple branching storylines, you'll need
          to adapt your strategy to succeed.
        </Trans>
      </p>
      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>9 unique girls to seduce</Trans>
      </h2>
      <p className="mb-4 leading-relaxed">
        <Trans>
          From the shy and innocent to the bold and seductive, each girl has her
          own distinct personality, quirks, and preferences. Get to know them,
          and find the perfect way to sweep them off their feet.
        </Trans>
      </p>
      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>18 unique locations to explore</Trans>
      </h2>
      <p className="mb-4 leading-relaxed">
        <Trans>
          When the chemistry is right, and the girl is ready, choose from 2
          unique locations to meet and satisfy your desires. From intimate
          encounters to passionate trysts, the options are endless.
        </Trans>
      </p>
      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>Unleash Your Fantasies</Trans>
      </h2>
      <p className="mb-4 leading-relaxed">
        <Trans>
          With over 70+ sex poses to choose from for each girl, you'll be
          spoiled for choice. Explore your deepest desires, and experience the
          ultimate thrill of intimacy.
        </Trans>
      </p>
      <h3 className="text-gray-600 text-xl font-medium mb-2">
        <Trans>What's in Store for You?</Trans>
      </h3>
      <ul className="list-disc pl-5 mb-4">
        <li className="mb-2">
          <Trans>
            9 unique girls with distinct personalities and storylines
          </Trans>
        </li>
        <li className="mb-2">
          <Trans>
            Multiple branching storylines, where every choice matters
          </Trans>
        </li>
        <li className="mb-2">
          <Trans>
            2 unique locations for each girl to meet and satisfy your desires
          </Trans>
        </li>
        <li className="mb-2">
          <Trans>Over 70+ sex poses for each girl to choose from</Trans>
        </li>
        <li className="mb-2">
          <Trans>A fully immersive adult dating app simulator experience</Trans>
        </li>
      </ul>
      <p className="leading-relaxed">
        <Trans>
          Join the LewdSpace community today, and discover a world of seduction,
          desire, and passion. Will you be able to seduce them all? There's only
          one way to find out.
        </Trans>
      </p>
      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>Support us on:</Trans>
      </h2>
      <div className="flex flex-col items-center mb-8 max-w-md mx-auto">
        <a
          href="https://subscribestar.adult/lewdspace"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <img
            src="/public/subscribeStar.png"
            alt="Support us on SubscribeStar"
            className="w-full hover:opacity-80 transition-opacity object-contain"
          />
        </a>
        {/* <a
          href="https://www.patreon.com/c/LewdSpace"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <img
            src="/public/patreon2.png"
            alt="Support us on Patreon"
            className="w-full hover:opacity-80 transition-opacity object-contain"
          />
        </a> */}
      </div>

      <h2 className="text-gray-700 text-2xl font-semibold mb-3">
        <Trans>Contact us:</Trans>
      </h2>
      <div className="flex flex-col items-start mb-8 max-w-md mx-auto">
        <p>
          email:{' '}
          <a href="mailto:info@lewdspace.com" className="w-full underline">
            info@lewdspace.com
          </a>
        </p>
        <p>
          discord:{' '}
          <a href="https://discord.gg/gwZKNENRdx" className="w-full underline">
            https://discord.gg/gwZKNENRdx
          </a>
        </p>
      </div>

      <footer className="mt-10 text-center">
        <ul className="list-none p-0">
          <li className="inline-block mx-2">
            <a href="/terms" className="text-blue-500 hover:underline">
              <Trans>Terms</Trans>
            </a>
          </li>
          <li className="inline-block mx-2">
            <a href="/privacy" className="text-blue-500 hover:underline">
              <Trans>Privacy</Trans>
            </a>
          </li>
          <li className="inline-block mx-2">
            <a
              href={`/${params.lang || 'en'}/app/home`}
              className="text-blue-500 hover:underline"
            >
              <Trans>Game</Trans>
            </a>
          </li>
          <li className="inline-block mx-2">
            <a
              href={`/${params.lang || 'en'}/sitemap`}
              className="text-blue-500 hover:underline"
            >
              <Trans>Sitemap</Trans>
            </a>
          </li>
          <li className="inline-block mx-2">
            <a
              href="mailto:info@lewdspace.com?subject=Report%20Issue&body=Please%20describe%20the%20issue%20you%20are%20reporting:"
              className="text-blue-500 hover:underline"
            >
              <Trans>Report an Issue</Trans>
            </a>
          </li>
        </ul>
      </footer>
    </div>
  );
};

const DiscordIcon = (props: any) => (
  <SvgIcon {...props} fontSize="inherit" style={{ fontSize: '1.5em' }}>
    <svg
      data-bbox="1 1 500 500"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      data-type="color"
    >
      <g>
        <path
          d="M329 501H1V1h500v500H329m36.985-80.515c37.397-12.068 71.983-29.687 103.769-52.766 1.807-1.312 3.84-3.641 4.027-5.658 2.866-30.972 2.295-61.884-2.305-92.689-8.28-55.446-29.063-106.02-59.018-153.15-4.476-7.04-9.82-11.99-17.716-14.228-25.455-7.216-50.927-14.374-76.375-21.614-2.898-.824-4.662-.113-5.974 2.68-2.83 6.026-5.745 12.023-8.974 17.838-.698 1.256-2.982 2.567-4.337 2.384-32.068-4.33-64.104-4.328-96.172 0-1.353.184-3.635-1.133-4.332-2.39-3.227-5.817-6.137-11.817-8.973-17.84-1.312-2.787-3.07-3.437-5.986-2.68-7.734 2.01-15.63 3.45-23.279 5.728-19.293 5.746-38.555 11.623-57.66 17.958-3.65 1.21-7.48 4.118-9.615 7.319C42.567 187.073 19.88 270.093 28.123 361.08c.192 2.126 1.633 4.784 3.34 6.033 32.533 23.79 68.032 41.778 106.444 54.042 3.054.975 4.916.697 6.618-2.127 6.528-10.83 13.214-21.567 19.784-32.373.644-1.058.896-2.354 1.295-3.443l-37.105-17.976c7.058-8.166 7.745-8.295 15.76-4.935 71.237 29.874 142.474 29.835 213.687-.087 7.602-3.193 9.408-2.718 15.405 5.12l-38.057 18.425c7.345 11.697 14.52 22.885 21.416 34.244 2.237 3.683 4.746 4.757 9.275 2.481z"
          fill="#5366F5"
          data-color="1"
        ></path>
        <path
          d="M365.616 420.622c-4.16 2.14-6.67 1.065-8.906-2.618-6.896-11.359-14.071-22.547-21.416-34.244l38.057-18.425c-5.997-7.838-7.803-8.313-15.405-5.12-71.213 29.922-142.45 29.96-213.688.087-8.014-3.36-8.7-3.23-15.76 4.935l37.106 17.976c-.399 1.089-.651 2.385-1.295 3.443-6.57 10.806-13.256 21.542-19.784 32.373-1.702 2.824-3.564 3.102-6.618 2.127-38.412-12.264-73.91-30.252-106.443-54.042-1.708-1.249-3.149-3.907-3.341-6.033-8.244-90.988 14.444-174.008 64.942-249.704 2.135-3.2 5.966-6.11 9.615-7.32 19.105-6.334 38.367-12.21 57.66-17.957 7.65-2.278 15.545-3.719 23.28-5.728 2.915-.757 4.673-.107 5.985 2.68 2.836 6.023 5.746 12.023 8.973 17.84.697 1.257 2.98 2.574 4.332 2.39 32.068-4.328 64.104-4.33 96.172 0 1.355.183 3.64-1.128 4.337-2.384 3.229-5.815 6.145-11.812 8.974-17.838 1.312-2.793 3.076-3.504 5.974-2.68 25.448 7.24 50.92 14.398 76.375 21.614 7.897 2.238 13.24 7.188 17.716 14.228 29.955 47.13 50.739 97.704 59.018 153.15 4.6 30.805 5.171 61.717 2.305 92.689-.187 2.017-2.22 4.346-4.027 5.658-31.786 23.079-66.372 40.698-104.138 52.903m-190.04-107.427c11.518.202 21.063-4.225 28.837-12.54 16.011-17.126 16.659-45.794 1.523-63.693-15.925-18.831-42.93-18.803-58.777.098-6.52 7.776-9.823 16.877-10.826 26.896-2.49 24.889 15.02 47.375 39.243 49.239m115.743-21.122c8.378 13.937 20.238 22.216 36.95 20.918 16.405-1.275 27.27-10.982 33.483-25.619 6.926-16.314 5.46-32.352-4.557-47.09-15.695-23.092-47.295-23.397-63.225-.469-11.379 16.377-11.558 33.844-2.651 52.26z"
          fill="#FFFFFF"
          data-color="2"
        ></path>
        <path
          d="M175.113 313.17c-23.76-1.839-41.27-24.325-38.78-49.214 1.003-10.019 4.306-19.12 10.826-26.896 15.847-18.9 42.852-18.93 58.777-.098 15.136 17.9 14.488 46.567-1.523 63.693-7.774 8.315-17.319 12.742-29.3 12.515z"
          fill="#5467F5"
          data-color="3"
        ></path>
        <path
          d="M291.149 291.743c-8.737-18.086-8.558-35.553 2.82-51.93 15.931-22.928 47.531-22.623 63.226.469 10.017 14.738 11.483 30.776 4.557 47.09-6.214 14.637-17.078 24.344-33.484 25.619-16.711 1.298-28.571-6.98-37.12-21.248z"
          fill="#5467F5"
          data-color="3"
        ></path>
      </g>
    </svg>
  </SvgIcon>
);

// const ItchIcon = (props: any) => (
//   <SvgIcon {...props} fontSize="inherit" style={{ fontSize: '1.5em' }}>
//     <svg
//       data-bbox="1 1 500 500"
//       viewBox="0 0 500 500"
//       xmlns="http://www.w3.org/2000/svg"
//       data-type="ugc"
//     >
//       <g>
//         <path
//           d="M501 195v306H1V1h500v194M88.137 48.146c-1.81.618-3.875.864-5.388 1.91C64.177 62.9 49.25 79.452 35.851 97.382c-4.518 6.047-9.89 12.794-10.929 19.805-1.775 11.995-2.193 24.612 2.86 36.412 4.615 10.778 11.937 19.315 22.24 24.8 8.319 4.43 16.897 7.531 26.954 4.595 10.223-2.985 19.141-7.427 26.227-15.464 6.009-6.815 9.327-14.872 11.223-24.585 5.768 25.054 21.266 39.603 44.588 41.467 5.172.413 10.832-1.608 15.821-3.617 5.006-2.016 9.991-4.812 13.996-8.377 4.137-3.682 7.646-8.383 10.386-13.228 2.55-4.51 3.724-9.797 5.538-14.837 6.31 27.665 24.416 39.105 45.23 39.559 24.034.524 41.265-13.321 48.2-38.094 5.682 23.487 21.203 37.934 43.84 38.112 24.38.19 40.893-14.627 46.373-39.757.495 1.19.6 2.014.78 2.822 5.408 24.16 29.609 41.05 52.073 35.787 16.207-3.797 27.007-14.373 33.714-29.382 4.986-11.159 2.772-22.973 3.088-34.539.064-2.357-.692-5.031-1.888-7.082-14.031-24.047-32.72-43.957-54.817-60.721-1.67-1.268-4.319-1.655-6.537-1.73-17.483-.583-34.972-1.015-52.46-1.447-15.973-.396-31.947-.734-48.62-1.734-1.747-.38-3.494-1.088-5.242-1.092-31.628-.066-63.256-.08-94.884.03-1.992.006-3.98 1.126-6.697 1.977-11.622.016-23.243.033-35.565-.408-.798-.207-1.594-.592-2.392-.594-13.303-.039-26.607-.085-39.91.047-1.505.015-3 1.093-5.22 1.917-3.934.009-7.869.018-12.506-.419-7.468.192-14.935.384-23.178.542m260.071 404.542c.274-.162.528-.351 1.675-.78 5.038-.305 10.077-.61 15.37-.799l.406.002s.366-.201 1.127-.298c3.069-.281 6.137-.563 9.469-.723.293.067.555-.009 1.584-.302 1.335.056 2.67.112 4.394-.094.267-.165.514-.358 1.607-.785 3.379-.328 6.757-.656 10.719-.571 1.295-.34 2.59-.68 4.497-1.327 6.402-1.104 12.772-2.478 19.215-3.224 5.2-.603 8.656-3.14 10.739-7.692 2.07-4.525 4.345-9.024 5.785-13.76 5.218-17.157 7.631-34.937 7.848-52.702.594-48.635.296-97.284.085-145.926-.038-8.567-1.367-17.129-2.119-25.923-10.693.88-20.623-.316-29.021-5.801-8.157-5.327-15.349-12.13-22.925-18.252-10.159 15.636-25.294 24.387-44.996 24.246-19.632-.14-34.306-9.719-45.087-25.93-20.52 33.79-72.135 35.561-94.316.174-10.77 16.297-25.588 25.713-45.33 25.846-19.795.134-34.866-8.986-45.813-25.578-12.625 17.614-28.972 26.818-50.611 25.393-.466 2.866-.9 5.46-1.301 8.06-.102.656-.116 1.327-.146 1.992-2.768 61.427-4.426 122.854 1.078 184.225 1.236 13.782 4.008 27.236 9.596 40.069 3.051 7.006 7.289 11.216 15.328 12.089 10.867 1.18 21.622 3.39 33.203 5.667 2.443.284 4.886.569 7.98.217 6.564.54 13.13 1.079 19.952 1.778l.432.058s.41-.181 1.26-.326c4.35.375 8.699.75 13.424 1.434.574-.086 1.147-.17 2.592-.392 5.676.363 11.352.726 17.538 1.502 1.19-.101 2.38-.202 4.44-.46 8.684.348 17.368.696 26.569 1.46 1.197-.128 2.394-.256 4.51-.55 6.017.147 12.033.294 18.453 1.082.87.385 1.738 1.094 2.613 1.104 7.899.093 15.8.133 23.698-.01 1.095-.02 2.17-1.121 4.172-1.938 6.35-.026 12.7-.052 19.434.22.572-.103 1.144-.206 2.647-.332 8.67-.286 17.34-.571 26.538-.472a65.662 65.662 0 0 1 4.456-.539c3.608.042 7.216.084 11.226-.137.277-.165.533-.355 1.686-.782 4.64.015 9.28.03 14.32-.213z"
//           fill="#FA5C5C"
//         ></path>
//         <path
//           d="M147.942 451.82a3396.91 3396.91 0 0 1-20.258-1.707c-3.107-.272-5.65-.455-8.194-.639-10.803-1.768-21.558-3.978-32.425-5.157-8.04-.873-12.277-5.083-15.328-12.09-5.588-12.832-8.36-26.286-9.596-40.068-5.504-61.371-3.846-122.798-1.078-184.225.03-.665.044-1.336.146-1.993.402-2.599.835-5.193 1.3-8.06 21.64 1.426 37.987-7.778 50.612-25.392 10.947 16.592 26.018 25.712 45.814 25.578 19.74-.133 34.559-9.549 45.33-25.846 22.18 35.387 73.795 33.615 94.315-.174 10.78 16.211 25.455 25.79 45.087 25.93 19.702.14 34.837-8.61 44.996-24.246 7.576 6.122 14.768 12.925 22.925 18.252 8.398 5.485 18.328 6.682 29.021 5.801.752 8.794 2.081 17.356 2.119 25.923.211 48.642.509 97.29-.085 145.926-.217 17.765-2.63 35.545-7.848 52.702-1.44 4.736-3.714 9.235-5.785 13.76-2.083 4.551-5.54 7.09-10.739 7.692-6.443.746-12.813 2.12-19.982 3.332-1.95.341-3.132.574-4.314.807-3.378.327-6.756.655-10.832 1.085-.898.384-1.099.665-1.3.946a231.09 231.09 0 0 0-4.671-.162c-.839.062-1.01.118-1.18.173-3.069.282-6.137.564-9.848.854-.81.062-.978.116-1.146.17-5.038.306-10.077.61-15.838 1.018-.932.38-1.142.659-1.352.937-4.64-.015-9.28-.03-14.646.057-.938.383-1.15.662-1.362.941a872.137 872.137 0 0 1-11.683-.19c-1.948.03-3.036.125-4.125.22-8.67.285-17.34.57-26.823.79-1.28-.01-1.75.045-2.217.1-6.35.026-12.7.052-19.972.113-10.602.079-20.284.123-29.965.168-6.017-.147-12.033-.294-18.913-.452-1.964.041-3.064.093-4.164.145-8.684-.348-17.368-.696-26.887-1.063-1.93.01-3.022.038-4.115.066-5.676-.363-11.352-.726-17.807-1.12-1.249.018-1.719.066-2.19.114-4.348-.375-8.697-.75-13.744-1.129-.883.035-1.068.074-1.253.112m32.276-94.596c-.32-4.084 2.3-3.402 4.903-3.186 18.401 1.524 36.785 3.569 55.22 4.292 25.64 1.005 51.246-.274 77.53-4.34h4.204c.784 10.353 3.141 20.084 8.664 28.9 16.492 26.322 48.535 31.598 73.245 25.332 7.389-1.873 11.653-7.078 13.203-14.72 2.08-10.252.693-20.303-1.798-30.133-5.018-19.801-10.443-39.505-16-59.164-4.826-17.074-9.035-34.31-17.535-50.208-14.137-26.442-33.612-36.922-61.677-32.121-11.51 1.97-20.646 7.953-28.93 16.975-1.442-.005-2.884-.01-5.196-.032-3.672-.309-7.344-.617-11.704-1.125-.472.05-.944.098-2.344.137-6.31.009-12.621.017-19.259-.54-.94.19-1.88.38-3.748.61-8.674.072-17.348.144-26.556.212-.207.28-.415.562-1.469.837a749.535 749.535 0 0 1-6.726-.085c-.294.348-.588.697-.79.317-1.754-1.111-3.87-1.896-5.204-3.383-17.144-19.123-57.274-22.026-76.166 1.996-8.759 11.136-15.913 23.097-19.977 36.534-7.498 24.795-14.5 49.751-21.13 74.794-2.88 10.877-4.924 22.061-6.275 33.236-1.884 15.569 4.871 25.038 18.975 27.209 12.603 1.94 25.217 1.554 37.474-2.613 22.307-7.585 38.127-27.531 39.066-49.731z"
//           fill="#FFFEFE"
//         ></path>
//         <path
//           d="M180.109 357.611c-1.491-4.563-.244-6.024 4.803-5.34 26.516 3.594 53.164 5.49 79.9 4.596 14.883-.498 29.717-2.428 44.581-3.61 2.275-.18 4.594.195 7.241.506-25.047 4.292-50.652 5.571-76.293 4.566-18.435-.723-36.819-2.768-55.22-4.292-2.604-.216-5.223-.898-5.012 3.574z"
//           fill="#FA5E5F"
//         ></path>
//         <path
//           d="M291.671 238.746c-1.132.108-2.69.32-4.498.31 1.19-.216 2.632-.211 4.498-.31z"
//           fill="#F94E4F"
//         ></path>
//         <path
//           d="M252.908 237.572c-.73.407-1.622.531-2.75.471.706-.374 1.646-.564 2.75-.47z"
//           fill="#F94E4F"
//         ></path>
//         <path
//           d="M274.691 237.793c-.231.185-.807.27-1.57.2.282-.202.754-.25 1.57-.2z"
//           fill="#F94E4F"
//         ></path>
//         <path
//           d="M222.707 238.114c.035.222-.217.414-.69.71.008-.15.216-.431.69-.71z"
//           fill="#F94E4F"
//         ></path>
//         <path
//           d="M214.642 238.878c.036.26-.324.507-.982.892-.003-.209.291-.558.982-.892z"
//           fill="#F94E4F"
//         ></path>
//         <path
//           d="M290.94 314.846h-18.457c0 5.512-.189 11.61.07 17.688.156 3.65-.966 5.001-4.74 4.934-10.961-.196-21.93-.163-32.892-.02-3.556.047-5.067-.951-4.868-4.814.315-6.1.084-12.227.084-17.807-6.398 0-12.276 0-18.965-.062-1.274.007-1.738.077-2.202.148l-5.363-.368c13.962-18.893 31.076-33.86 47.709-50.118 16.517 15.913 33.441 30.963 47.73 49.987-2.437.143-3.827.225-5.957.3a27.1 27.1 0 0 0-2.148.132z"
//           fill="#FFFEFE"
//         ></path>
//         <path
//           d="M291.13 314.999c.28-.2.75-.247 1.564-.2-.23.18-.802.266-1.564.2z"
//           fill="#F94B4C"
//         ></path>
//         <path
//           d="M209.163 315.056c.27-.214.735-.284 1.545-.28-.219.19-.785.307-1.545.28z"
//           fill="#F94C4C"
//         ></path>
//       </g>
//     </svg>
//   </SvgIcon>
// );
